import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
// Sample logos (replace with actual logo URLs or import images)
const customers = [
    {
        name: "Mody University",
        logo: "./customers/modyuniverisitylogo.png",
    },
    {
        name: "Mission Gyan",
        logo: "./customers/missiongyanlogo.png",
    },
    {
        name: "Almuntasebaat",
        logo: "./customers/almuntasebaatlogo.png",
    },
    {
        name: "Suratjamaat",
        logo: "./customers/suratjamaatlogo.png",
    },
    {
        name: "Jat Aviation",
        logo: "./customers/jataviationlogo.png",
    },
    {
        name: "Ms2",
        logo: "./customers/ms2logo.png",
    },
    {
        name: "Shop Ustaad",
        logo: "./customers/shopustaadlogo.jpeg",
    },
    {
        name: "Mody School",
        logo: "./customers/modyschoollogo.png",
    },
    {
        name: "Online Mody University",
        logo: "./customers/onlinemodylogo.jpg",
    },
     {
        name: "Jat Polo Club",
        logo: "./customers/jatpoloclub.png",
    },
     {
        name: "HR Design Studio",
        logo: "./customers/hrlogo.jpg",
    },
];

const Customers = () => {
    return (
        <div style={styles.container}>
            <h2 style={styles.heading}>Our Customers</h2>
            <Swiper
                modules={[Autoplay, Pagination, Navigation]}
                slidesPerView={4}
                spaceBetween={32}
                
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                loop={true}
                breakpoints={{
                    320: { slidesPerView: 1 },
                    640: { slidesPerView: 2 },
                    900: { slidesPerView: 4 },
                }}
                style={{ maxWidth: "900px", margin: "0 auto", padding: "20px 0" }}
            >
                {customers.map((customer, idx) => (
                    <SwiperSlide key={idx}>
                        <div style={styles.card} className="customer-card">
                            <img
                                src={customer.logo}
                                alt={customer.name}
                                style={styles.logo}
                                className="customer-logo"
                            />
                            <div style={styles.name}>{customer.name}</div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <style>
                {`
                    .customer-card {
                        transition: transform 0.3s, box-shadow 0.3s;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.07);
                    }
                    .customer-card:hover {
                        transform: translateY(-10px) scale(1.05) rotate(-2deg);
                        box-shadow: 0 8px 24px rgba(0,0,0,0.15);
                        background: #f0f8ff;
                    }
                    .customer-logo {
                        filter: grayscale(40%);
                        transition: filter 0.3s;
                    }
                    .customer-card:hover .customer-logo {
                        filter: grayscale(0%);
                    }
                `}
            </style>
        </div>
    );
};

const styles = {
    container: {
        padding: "40px 20px",
        background: "linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%)",
        
    },
    heading: {
        textAlign: "center",
        fontSize: "2.5rem",
        marginBottom: "32px",
        fontWeight: "bold",
        letterSpacing: "2px",
        color: "#2d3748",
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
        gap: "32px",
        maxWidth: "900px",
        margin: "0 auto",
    },
    card: {
        background: "#fff",
        borderRadius: "18px",
        padding: "28px 16px 18px 16px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
        minHeight: "180px",
    },
    logo: {
        width: "70px",
        height: "70px",
        objectFit: "contain",
        marginBottom: "18px",
        borderRadius: "12px",
        background: "#f3f4f6",
        padding: "8px",
    },
    name: {
        fontSize: "1.1rem",
        fontWeight: "600",
        color: "#374151",
        textAlign: "center",
        letterSpacing: "1px",
    },
};

export default Customers;